import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center text-center">
        <Col md={8} lg={6}>
          <div className="mb-4">
            <h1 className="display-1 text-muted">404</h1>
            <h2 className="h3 mb-3">Seite nicht gefunden</h2>
            <p className="text-muted mb-4">
              Die Seite, die du suchst, existiert nicht oder wurde verschoben.
            </p>
          </div>
          
          <div className="d-flex gap-3 justify-content-center">
            <Button as={Link} to="/" variant="primary">
              <Home size={16} className="me-2" />
              Zur Startseite
            </Button>
            <Button variant="outline-secondary" onClick={() => window.history.back()}>
              <ArrowLeft size={16} className="me-2" />
              Zurück
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage;
